import React from "react";
import { Box, Typography, Divider, Button } from "@mui/material";

const Procesos = ({ handleClose }) => {
  return (
    <Box
      sx={{
        mt: 1,
        mx: "auto",
        width: "100%",
        maxWidth: 1250,
        textAlign: "center",      
        borderRadius: 1,
      }}
    >
      <Typography
        variant="h4"
        gutterBottom
        sx={{ fontSize: "large", fontWeight:"bold", p: 1 }}
      >
        PROCEDIMIENTO DE DENUNCIA
      </Typography>
      <Divider sx={{ mb: 2}} />
      <Box
        component="img"
        src="../../assets/procesoIMG.jpg"
        alt="Imagen del Procedimiento"
        sx={{
          width: "100%",
          height: "100%",
          mb: 2,
        }}
      />
      <Box display="flex" justifyContent="center" mt={2}>
        <Button variant="contained" color="primary" onClick={handleClose}>
          CERRAR
        </Button>
      </Box>
    </Box>
  );
};

export default Procesos;
